import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Place';
import IconButton from '@mui/material/IconButton';
import MarkerMap from '../../../Components/common/Maps';
import Button from '../../../Components/common/Button';
import CustomDialog from '../../../Components/common/Dialog';
import CustomTextField from '../../../Components/common/TextField';
import CustomTooltip from '../../../Components/common/Tooltip';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { notifyError, notifySuccess, sendLocation } from '../../../Utils';

export const UpdateAssetTracker = (props) => {
    const dispatch = useDispatch()
    const loginUser = useSelector((state) => state.logInUsers)
    const themecolors = useSelector((state) => state.themeColors)
    const deviceData = useSelector((state) => state.deviceRelatedData)

    const [form, setForm] = useState({
        latitude: '',
        longitude: '',
        zoom: 0
    });
    const [isMapModal, setIsMapModal] = useState(false);
    const [localPosition, setLocalPosition] = useState(null);
    const [isVisableAddlocBtn, setIsVisableAddlocBtn] = useState(false);

    useEffect(() => {
        if (props.device) {
        const position = deviceData[props.device.id]
            setForm((prevform) => ({
                ...prevform,
                latitude: position?.latitude || '',
                longitude: position?.longitude || '',
            }))
        }
    }, [deviceData,props.device?.id]);

    const handleClickShowPostion = () => {
        setIsMapModal(true);
        setIsVisableAddlocBtn(false);
    };

    const getPostion = (latlng, zoom) => {
        if (latlng.lat && latlng.lng && zoom) {
            setLocalPosition({ latlng, zoom });
            setIsVisableAddlocBtn(true);
        }
    };

    const setSelectedLocation = () => {
        if (localPosition) {
            setForm((prev) => ({
                ...prev,
                latitude: localPosition.latlng.lat,
                longitude: localPosition.latlng.lng,
            }))
            setIsMapModal(false);
        }
    };

    const handleChange = (name) => (event) => {
        let value = event.target.value;
        if (event.target.type === 'number') {
            value = parseFloat(value);
        }
        setForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        const data = {
            device: props.device,
            form: form,
            userId: loginUser.id,
        };

        try {
            const result = await sendLocation(data);
            if (result.success) {
                dispatch(notifySuccess("Position send successfully"))
                props.onCloseModal()
            }
        } catch (err) {
            dispatch(notifyError("Error position send:", err))
        }
    };


const isValid = form.latitude && form.longitude && form.remarks
// const originalLatitude = deviceData[props.device?.id]?.latitude || "";
// const originalLongitude = deviceData[props.device?.id]?.longitude || "";
// const isChanged =form.latitude !== originalLatitude ||form.longitude !== originalLongitude 
const canSave = isValid;

    return (
        <div>
            {isMapModal && (
                <CustomDialog
                    title={props.translate("setLocation")}
                    themecolors={props.themecolors}
                    visable={true}
                    onClose={() => setIsMapModal(false)}
                    isVisableBtn={true}
                    draggable={true}
                    CancelText={props.translate("sharedBack")}
                    headerActions={
                        <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            disabled={!isVisableAddlocBtn}
                            onClick={setSelectedLocation}
                        >
                            {props.translate("sharedAdd")}
                        </Button>
                    }
                    bodyPadding={0}
                >
                    <MarkerMap
                        getPostion={getPostion}
                        minHeight={500}
                        zoom={form.zoom || 0}
                        lat={form.latitude || 0}
                        lng={form.longitude || 0}
                        height={"100%"}
                    />
                </CustomDialog>
            )}

            <Box sx={{ p: 2 }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item md={5} sm={6} xs={12}>
                        <CustomTextField
                            id="latitude"
                            type="number"
                            label={props.translate("positionLatitude")}
                            value={form.latitude}
                            onChange={handleChange("latitude")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                        />
                    </Grid>
                    <Grid item md={5} sm={6} xs={12}>
                        <CustomTextField
                            id="longitude"
                            type="number"
                            label={props.translate("positionLongitude")}
                            value={form.longitude}
                            onChange={handleChange("longitude")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                        />
                    </Grid>
                    <Grid item md={2} sm={6} xs={12}>
                        <CustomTooltip title={props.translate("addLocation")}>
                            <IconButton
                                onClick={handleClickShowPostion}
                                sx={{
                                    mt: { xs: 0, sm: 0 },
                                    border: "1px solid white",
                                    borderColor: "divider",
                                    color: themecolors?.textColor || "white"
                                }}
                            >
                                <EditIcon />
                            </IconButton>
                        </CustomTooltip>
                    </Grid>

                    <Grid item md={12} sm={12} xs={12}>
                        <CustomTextField
                            id="remarks"
                            type="text"
                            required
                            label={props.translate("remarks")}
                            value={form.remarks || ""}
                            onChange={handleChange("remarks")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            multiline
                            minRows={3}
                        />
                    </Grid>
                </Grid>

                <Box sx={{ mt: 3 }}>
                    <Button variant="contained" onClick={handleSubmit} disabled={!canSave} >
                    {props.translate("sharedSave")}
                    </Button>
                </Box>
            </Box>
        </div>
    );
};
